import { useAuthStore } from '@/stores/auth';
import type { ContentWithAvailableArea } from '@/types/feed-entrys';

/**
 * Type guard to check if an entry conforms to the ContentWithAvailableArea interface.
 * @param entry - The entry to check.
 * @returns True if the entry is a ContentWithAvailableArea.
 */
export function isContentWithAvailableArea(
  entry: any,
): entry is ContentWithAvailableArea {
  return (
    entry !== null &&
    entry !== undefined &&
    typeof entry === 'object' &&
    'availableArea' in entry
  );
}

/**
 * Determines whether the current user can view the given entry based on its available area.
 * Uses the auth store to get the current user.
 * @param entry - The content entry to check.
 * @returns True if the current user can view the entry.
 */
export function canView(entry: ContentWithAvailableArea): boolean {
  const authStore = useAuthStore();
  const user = authStore.user;

  if (
    typeof entry !== 'undefined' &&
    entry?.availableArea !== undefined &&
    [0, 1, 2].includes(entry.availableArea)
  ) {
    /**
     * availableArea
     * 0: internal only
     * 1: all (internal + external)
     * 2: external only
     */
    if (user !== null) {
      return entry.availableArea === 0 || entry.availableArea === 1;
    }
    return entry.availableArea === 2 || entry.availableArea === 1;
  }
  return false;
}
